import { Component, OnInit, Input, ViewChild, ViewContainerRef, ViewRef } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { Subscription } from 'rxjs';
import { SearchComponent } from '../document/search/search.component';
import { ListComponent } from '../document/list/list.component';
import { DetailsComponent } from '../document/details/details.component';
import { UploadFormComponent } from '../upload-form/upload-form.component';
import { NxTabChangeEvent, NxTabGroupComponent } from '@aposin/ng-aquila/tabs';
import { NxMessageToastService } from '@aposin/ng-aquila/message';

@Component({
	selector: 'app-tabs',
	templateUrl: './tabs.component.html',
	styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {
	readonly toastText = 'Es können nur 6 Tabs parallel geöffnet werden.';

  /* Tab view will be dynamically loaded on demand. This container will represent the loaded component*/
  @ViewChild('container', { read: ViewContainerRef, static: true }) container!: ViewContainerRef;

  /* Two ways of spawning a new component:
    1. Component interaction based: Menu -> Search/Import, Search <-> List, List -> Details/Versions. Link will be null
    2. Link based: Link will be bypassed to Search/Details. Using the link, comps will query the back-end for data.
  */
  linkId?: string;

  /* Must not be empty. This can create issues because tabs and containers length don't match*/
  tabList: string[] = ['eAkte'];
  containerList : ViewRef[] = [];

  /* TabsComponent is the orchestrator, therefore all dynamically loaded components will need to notify it. */
  subscription: Subscription;

  selectedIndexNo: number = 0;
  indexImport: number = 0;
  indexSearch: number = 0;
  indexList: number = 0;
  indexDetails: number = 0;
  indexVersions: number = 0;

  constructor(private sharedService: SharedService, private readonly messageToastService: NxMessageToastService) {
  	this.subscription = this.sharedService.getMessage().subscribe((message: any) => {
  		if (this.tabList.length > 6) {
  			this.numberOfTabExceedNotification();
  		} else {
  			if (message.text === 'Neuer import') {
  				this.createImportTab();
  			} else if (message.text === 'Neue Suche') {
  			  this.createSearchTab();
      	} else if (message.text === 'search') {
      	  this.createListTab(message);
      	} else if (message.text === 'details') {
  				this.createDetailsTab(message);
      	} else if (message.text === 'showVersions') {
  				this.createVersionListTab(message);
      	} else if (message.text === 'modifySearch') {
  				this.createModifySearchCriteriaTab(message);
      	} else if (message.text === 'detailsLink') {
      	  const linkId: string = String(message.payload);
      	  this.createDetailsTabFromLink(linkId);
      	} else if (message.text === 'importSimilar') {
      	  this.createImportSimilarTab(message);
      	} else if (message.text === 'importDuplicate') {
  				this.createImportDuplicateTab(message);
  			} else if (message.text === 'similarSearch') {
  				this.createSimilarSearchTab(message);
  			}

      	const selectedIndexToBeRemoved = this.selectedIndexNo;
      	this.tabChanged(this.containerList.length);
      	/* Transform searchcomp into listcomp when performing modify search criteria*/
      	if (message.text === 'search' || message.text === 'modifySearch') {
      	  this.removeTab(selectedIndexToBeRemoved);
      	}
      	if (message.text === 'detailsLink') {
      	  this.removeTab(selectedIndexToBeRemoved - 1);
      	}
  		}
  	});
  }

  /* In case the user received a link.*/
  ngOnInit(): void {
  	const detailsLinkId = localStorage.getItem('details');
  	const listLinkId = localStorage.getItem('list');

  	setTimeout(()=>{
  		if (!!listLinkId) {
  			this.createListTabFromLink(listLinkId);
  			localStorage.removeItem('list');
  			this.selectedIndexNo++;
  		} else if (!!detailsLinkId) {
  			this.createDetailsTabFromLink(detailsLinkId);
  			localStorage.removeItem('details');
  			this.selectedIndexNo++;
  		}
  	}, 500);
  }

  createImportSimilarTab(payload: any) {
  	this.createImportSimilarComponent(payload);
  	this.indexImport++;
  	this.addTab('ECA Import ' + this.indexImport);
  }

  createImportDuplicateTab(payload: any) {
    	this.createImportDuplicateComponent(payload);
    	this.indexImport++;
    	this.addTab('ECA Import ' + this.indexImport);
  }

  createImportTab() {
  	this.createImportComponent();
  	this.indexImport++;
  	this.addTab('ECA Import ' + this.indexImport);
  }

  createSearchTab() {
  	this.createSearchComponent();
  	this.indexSearch++;
  	this.addTab('ECA Suche ' + this.indexSearch);
  }

  createSimilarSearchTab(message: any) {
  	this.createSimilarSearchComponent(message.payload);
  	this.indexSearch++;
  	this.addTab('ECA Suche ' + this.indexSearch);
  }

  createListTab(message: any) {
  	this.indexSearch--;
  	this.indexList++;
	const tabTitle = 'Suchergebnisliste ' + this.indexList;
	this.createSearchListWithFilterComponent(tabTitle, message.payload);
  	this.addTab(tabTitle);
  }

  createListTabFromLink(linkId: string) {
  	this.indexList++;
	const tabTitle = 'Suchergebnisliste' + this.indexList;
	this.createSearchListWithLinkComponent(tabTitle, linkId);  	
  	this.addTab(tabTitle);
  	this.selectedIndexNo++;
  }

  createDetailsTab(message: any) {
	// {documentMetadata: documentMetadata, filter: this.filter}
	this.indexDetails++;
	const tabTitle = 'ECA Index anzeigen ' + this.indexDetails;
	const widgetOneRef = this.container.createComponent(DetailsComponent);
  	widgetOneRef.instance.documentMetadata = message.payload!.documentMetadata;  
	widgetOneRef.instance.filter = message.payload!.filter;  	
	widgetOneRef.instance.tabTitle = tabTitle || 'ECA Index anzeigen';
  	this.containerList = [...this.containerList, widgetOneRef.hostView];	
  	this.addTab(tabTitle);
  	this.selectedIndexNo++;
  	/*   	this.indexDetails++;
  	this.addTab('ECA Index ' + this.indexDetails); */
  }

  createDetailsTabFromLink(linkId: string) {
  	this.indexDetails++;
	const tabTitle = 'ECA Index anzeigen ' + this.indexDetails;
	const widgetOneRef = this.container.createComponent(DetailsComponent);  	
  	widgetOneRef.instance.linkId = linkId;
	widgetOneRef.instance.tabTitle = tabTitle || 'ECA Index anzeigen';
  	this.containerList = [...this.containerList, widgetOneRef.hostView];

  	this.addTab(tabTitle);
  	this.selectedIndexNo++;
  }

  createDetailsWithDocumentComponent(payload: any, tabTitle: string) {
  	this.createDetailsComponent(tabTitle, payload, undefined);
  }

  createDetailsWithLinkComponent(linkId: string, tabTitle: string) {
  	this.createDetailsComponent(tabTitle, undefined, linkId);
  }

  createDetailsComponent(tabTitle: string, payload?: any, linkId?: string){
  	const widgetOneRef = this.container.createComponent(DetailsComponent);
  	widgetOneRef.instance.documentMetadata = payload;
  	widgetOneRef.instance.linkId = linkId;
	widgetOneRef.instance.tabTitle = tabTitle || 'ECA Index anzeigen';
  	this.containerList = [...this.containerList, widgetOneRef.hostView];
  }

  createVersionListTab(message: any) {
  	this.createVersionListComponent(message.payload, false);
  	this.indexVersions++;
  	this.addTab('Versionen ' + this.indexVersions);
  }

  createModifySearchCriteriaTab(message: any) {
  	this.indexList--;
  	this.createModifySearchComponent(message.payload);
  	this.indexSearch++;
  	this.addTab('ECA Suche ' + this.indexSearch);
  }

  numberOfTabExceedNotification() {
  	this.messageToastService.open(this.toastText, {
  		context: 'info',
  		duration: 5000,
  	});
  }

  createSearchComponent() {
  	const widgetOneRef = this.container.createComponent(SearchComponent);
  	this.containerList = [...this.containerList, widgetOneRef.hostView];
  }

  createSimilarSearchComponent(payload: any) {
  	const widgetOneRef = this.container.createComponent(SearchComponent);
  	widgetOneRef.instance.myMap = payload;
  	this.containerList = [...this.containerList, widgetOneRef.hostView];
  }

  createModifySearchComponent(payload: any) {
  	const widgetOneRef = this.container.createComponent(SearchComponent);
  	widgetOneRef.instance.filter = payload;	
  	this.containerList = [...this.containerList, widgetOneRef.hostView];
  }

  getSearchTitle(payload: any): string{
  	return 'ECA Suche ' + this.indexSearch
  }

  createImportComponent() {
  	const widgetOneRef = this.container.createComponent(UploadFormComponent);
  	this.containerList = [...this.containerList, widgetOneRef.hostView];
  }

  createImportSimilarComponent(message: any) {
  	const widgetOneRef = this.container.createComponent(UploadFormComponent);
  	widgetOneRef.instance.documentMetadata = message.payload;
  	widgetOneRef.instance.importSimilar = true;
  	this.containerList = [...this.containerList, widgetOneRef.hostView];
  }

  createImportDuplicateComponent(message: any) {
  	const widgetOneRef = this.container.createComponent(UploadFormComponent);
  	widgetOneRef.instance.documentMetadata = message.payload;
  	this.containerList = [...this.containerList, widgetOneRef.hostView];
  }

  createSearchListWithFilterComponent(tabTitle: string, payload: any) {
  	this.createSearchListComponent(tabTitle, payload, undefined);
  }

  createSearchListWithLinkComponent(tabTitle: string, linkId: string) {
  	this.createSearchListComponent(tabTitle, undefined, linkId);
  }

  createSearchListComponent(tabTitle: string, payload?: any, linkId?: string) {
  	const widgetOneRef = this.container.createComponent(ListComponent);
  	widgetOneRef.instance.filter = payload;
  	widgetOneRef.instance.showVersionsFlag = true;
  	widgetOneRef.instance.linkId = linkId;
	widgetOneRef.instance.tabTitle = tabTitle;
  	this.containerList = [...this.containerList, widgetOneRef.hostView];
  }

  createVersionListComponent(payload: any, showVersionsFlag: boolean) {
  	const widgetOneRef = this.container.createComponent(ListComponent);
  	widgetOneRef.instance.documents = payload;
  	widgetOneRef.instance.showVersionsFlag = showVersionsFlag;
  	this.containerList = [...this.containerList, widgetOneRef.hostView];
  }

  addTab(text: string) {
  	this.tabList = [...this.tabList, text];
  }

  removeTab(tabIndex: number) {
  	/* tabs list length = container list length + 1 */
  	const containerIndex = tabIndex - 1;
  	const widgetOneRef =  this.containerList[containerIndex];
  	this.tabList.splice(tabIndex, 1);
  	this.containerList.splice(containerIndex, 1);
  	this.selectedIndexNo--;
  	if (widgetOneRef) {
  		const containerIndexToBeRemoved: number = this.container.indexOf(widgetOneRef);
  		this.container.remove(containerIndexToBeRemoved);
  	}
  }

  changeTabTitle(oldTitle: string, newTitle: string) {
	console.log(`Changing tab title from ${oldTitle} to ${newTitle}`);
	const index = this.tabList.indexOf(oldTitle);
	if (index !== -1) {
		this.tabList[index] = newTitle;
		console.log(`Changing tab title from ${oldTitle} to ${newTitle} index ${index} - SUCCESS`);
	}
  }

  tabChangedEvent($event: NxTabChangeEvent) {
  	const index: number = $event.index - 1;
  	this.tabChanged(index);
  }

  tabChanged(index: number) {
  	const widgetOneRef =  this.containerList[index];
  	this.selectedIndexNo = index;
	try{
  		this.container.detach(0);
	}catch(error){
		console.error('Error detaching view', error);
	}
  	if (widgetOneRef) {
  		this.container.insert(widgetOneRef);
  	}
  }
}
